import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function TeamNameCell({ name, description }) {
  return (
    <Box sx={{ minWidth: 0, width: "100%" }}>
      <Typography
        sx={{
          color: "#061522",
          fontSize: 14,
          fontWeight: 500,
          fontFamily: "Inter",
          lineHeight: "18px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {name}
      </Typography>
      {description ? (
        <Typography
          sx={{
            color: "#556575",
            fontSize: 12,
            fontWeight: 400,
            fontFamily: "Inter",
            lineHeight: "18px",
            mt: 0.25,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {description}
        </Typography>
      ) : null}
    </Box>
  );
}
